"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffArray = void 0;
/**
 * Returns an object with 2 parameters. `additional` which is elements in `compare` that are not in `original`, and `missing` which are elements in `original` that are not in `compare`
 *
 * @param original The base array to compare against
 * @param compare The array to compare to
 */
exports.diffArray = (original, compare) => {
    const missing = original.filter((value) => {
        return compare.indexOf(value) === -1;
    });
    const additional = compare.filter((value) => {
        return original.indexOf(value) === -1;
    });
    return {
        additional,
        missing
    };
};
//# sourceMappingURL=diff-array.js.map